import React, { useMemo, useCallback } from 'react';
import { IItemForGetShortInfoWithStatus } from 'types';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setIDsRestaurant: (value: string[]) => void;
	restaurants: IItemForGetShortInfoWithStatus[];
	IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
	IDsSelectedRestaurant: string[];
	typeOfChanges: 'basedChanges' | 'independentChanges';
}

export const RestaurantsMultipleSelect: React.FC<IProps> = React.memo(
	({ setIDsRestaurant, restaurants, IDSelectedRestaurantOnRestPropsPage, IDsSelectedRestaurant, typeOfChanges }) => {
		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = IDsSelectedRestaurant.filter((el) => el !== id);
				setIDsRestaurant(updatedSelectedItems);
			},
			[IDsSelectedRestaurant, setIDsRestaurant],
		);

		const availableRestaurants = useMemo(() => {
			if (typeOfChanges === 'basedChanges') {
				return restaurants.filter((restaurant) => restaurant.id !== IDSelectedRestaurantOnRestPropsPage);
			}
			return restaurants;
		}, [typeOfChanges, restaurants, IDSelectedRestaurantOnRestPropsPage]);

		const restaurantsList = useMemo(() => {
			return IDsSelectedRestaurant.map((el) => {
				const label = availableRestaurants?.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [IDsSelectedRestaurant, availableRestaurants, handleRemove]);

		return (
			<div className={style.container} data-test="RestaurantsMultipleSelect">
				<MultipleSelect
					restaurants={availableRestaurants}
					setIDsRestaurant={setIDsRestaurant}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					typeOfChanges={typeOfChanges}
				/>
				<div className={style.groupsList}>{restaurantsList}</div>
			</div>
		);
	},
);
